import { ISelectorOptions } from 'components/common'

export const Roles = {
  admin: 'Admin',
  customer: 'Customer',
  owner: 'Owner',
  operator: 'Operator',
  sales: 'Sales',
  outOfHours: 'Out Of Hours',
  driverSubcontractor: 'Subcontractor',
  transportController: 'Transport Controller',
}

export const AvailableRoles: ISelectorOptions = [
  { value: Roles.customer, label: Roles.customer },
  { value: Roles.admin, label: Roles.admin },
  { value: Roles.operator, label: Roles.operator },
  { value: Roles.owner, label: Roles.owner, disabled: true },
  { value: Roles.sales, label: Roles.sales },
  { value: Roles.outOfHours, label: Roles.outOfHours },
  { value: Roles.driverSubcontractor, label: Roles.driverSubcontractor },
  { value: Roles.transportController, label: Roles.transportController },
]
